import type { DrawCountdown } from './rewardsPageTypes';
import { EARN_RING_CIRCUMFERENCE } from './earnHeroConstants';

export const pad2 = (n: number) => String(Math.max(0, Math.floor(n))).padStart(2, '0');

export const formatCompactCount = (value: number): string => {
  const n = Math.max(0, Math.floor(value));
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}m`;
  if (n >= 10_000) return `${Math.round(n / 1000)}k`;
  if (n >= 1_000) return `${(n / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  return n.toLocaleString('en-US');
};

export const getDaysInCurrentMonth = (date = new Date()) =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

export const getRingStrokeDashoffset = (daysLeft: number, monthDays?: number): number => {
  const total = monthDays && monthDays > 0 ? monthDays : getDaysInCurrentMonth();
  const clampedDays = Math.max(0, Math.min(total, daysLeft));
  const remainingRatio = clampedDays / total;
  return EARN_RING_CIRCUMFERENCE * (1 - remainingRatio);
};

export const formatCountdownHms = (countdown: DrawCountdown) => ({
  hours: pad2(countdown.hours),
  minutes: pad2(countdown.minutes),
  seconds: pad2(countdown.seconds),
});
